import { asCount } from '../../../../utils/counts';
import { openTasksLabel } from '../open-tasks';

/** How many open action items a venue has, in words. Nothing at zero or when the count is missing. */
export function OpenTasksChip({ count }: { count: number }) {
  const n = asCount(count);
  if (n === 0) return null;
  return (
    <span
      className="nb-pill"
      style={{
        height: 20,
        fontSize: 10.5,
        padding: '0 8px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        background: 'var(--nb-warn-soft)',
        color: 'var(--nb-ink)',
        // A visible edge, so the chip does not melt into a dark card.
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'var(--nb-warn)',
      }}
    >
      {openTasksLabel(n)}
    </span>
  );
}
